import React, { FC, ReactNode } from 'react';
import { Container } from './DropDownContainer.styles';

type Props = {
    children: ReactNode;
};
export const DropdownContainer: FC<Props> = (props) => {
    const { children } = props;
    return <Container>{children}</Container>;
};
